/**
 * Interface representing the options for vehicle road worthy checks notifications.
 */
export class VehicleRoadWorthyChecksNotificationOptions {
	/**
	 * Flag indicating if notifications are enabled
	 * @description If false, no notifications will be sent regardless of other settings.
	 */
	enabled!: boolean;

	/**
	 * Flag indicating if notifications for new records are enabled
	 * @description If false, no notifications will be sent.
	 */
	recordCreated?: boolean;

	/**
	 * Flag indicating if notifications for updated records are enabled
	 * @description If false, no notifications will be sent.
	 */
	recordUpdated?: boolean;

	/**
	 * Flag indicating if notifications for deleted records are enabled
	 * @description If false, no notifications will be sent.
	 */
	recordDeleted?: boolean;

	/**
	 * Flag indicating if notifications for status changes are enabled
	 * @description If false, no notifications will be sent.
	 */
	statusChanged?: boolean;
}
